import { NgModule } from '@angular/core';

import { VendorsModule } from './vendors.module';
import { PipesModule } from '../pipes/pipes.module';
import { DirectivesModule } from '../directives/directives.module';
import { ComponentsModule } from '../components/components.module';
import { AideModule } from '../aide/aide.module';
import { FormsModule } from '@angular/forms';

const modules = [VendorsModule, PipesModule, DirectivesModule, AideModule, ComponentsModule, FormsModule];

@NgModule({
  declarations: [],
  imports: [...modules],
  exports: [...modules],
  providers: [],
})
export class SharedModule {}
